module.exports = __webpack_public_path__ + "img/coin.881bc8dd.png";